<template lang="pug">
.report
  .no-convertion(v-show="target === 0")
    .no-convertion-panel
      img(src="https://p3.ssl.qhimg.com/t010462c200a27ad0b0.png")
      h3 开发中，请耐心等待...
  PageTitle(
    pagetitle="账户优化",
    tip="通过对您搜索推广账户进行问题诊断、问题原因分析给出优化建议，采纳建议将帮助您优化推广策略，提升广告推广及转化效果")
    a.floatr.btn.btn-primary.btn-custom(:href="toOperateList",
      target="_blank",
      v-show="dianjingID") 查看操作列表
    span.floatr(v-if="dianjingIDList.length > 0" @click.stop="stop")
      label 账号切换：
      v-select(
        v-model="dianjingID",
        :options="dianjingIDList")
  .zone.target-zone
    p 优化目标：
      v-radio-group(
          v-model = "target",
          name = "target",
          :options = "targetList"
        )
      v-tooltip(
        v-show="!noConvertion",
        :tip="'您的网站已收集到转化数据，优先推荐使用优化转化效果模板，优化展现点击建议包含在其中。'",
        pos="right")
        i.fa.fa-question-circle(style="margin-left: 5px;")

  .opt-container
    .no-convertion(v-show="(noConvertion && target == 1)")
      .no-convertion-panel
        img(src="https://p3.ssl.qhimg.com/t010462c200a27ad0b0.png")
        h3 Ops! 暂无数据
        .p.no-convertion-tip 由于您的日均转化次数低于 20 或未
          i.link-opt
            router-link(:to="'/setting/trans'") 设置转化目标
          | ，无法使用该优化目标进行账户优化

    ul.tab
      li.tab-item(v-for="item in tabViews")
        .tabview-btn(
                @click.stop="changeViewTo(item.comp)",
                :class="{ active: currentView === item.comp}"
              ) {{item.title}}

    p.select-plan(v-show="currentView == 'section'", @click.stop="stop") 筛选待优化计划
      v-tooltip(
        :tip="'按昨日数据进行筛选'",
        pos="right")
        i.fa.fa-question-circle(style="margin-left: 5px;")
      | ：
      v-radio-group(
          v-model = "selectPlanMethod",
          name = "method",
          :options = "planMethods"
        )
        span.custom-plan(slot="4" v-show="selectPlanMethod == 4")
          input.plan(
            type="text",
            :value="customPlanMethod",
            v-show="customPlanMethod != ''",
            @click.stop="editCustomPlanMethod",
            readonly
            )
          i.fa.fa-window-close-o(v-show="customPlanMethod != ''", @click.prevent.stop="closeCustomPlanMethod")
      span.custom-plan(slot="5" v-show="selectPlanMethod == 5")
        span.btn.btn-primary.btn-icon(@click.stop="searchPlanShow = true" v-show="!searchPlanShow && this.planList.length != 0") 重新选择
        .hand-custom-plan-select(v-show="searchPlanShow", @click.stop="stop")
          i.triangle
          input.search-plan(
            type="text",
            v-model="planName",
            @keyup.enter="getPlanList",
            placeholder="请输入搜索内容"
            )
          i.fa.fa-search( @click.prevent="getPlanList")
          p 已选{{planCheckedList.length}}个（最多选20个计划）
            span.floatr.btn.btn-primary.btn-icon(@click="resetCheckPlanList") 全部清空
          .plan-list
            label.label(v-for="plan in allPlanList", :title="plan.plan")
              v-checkbox(
                v-model="plan.checked",
                :title="plan.plan",
                @change.native="toggleCheckPlan(plan,$event)"
                )
          .btn-wrap.tr
              button.btn.btn-primary.btn-small(@click.stop="planMethodSubmit") 确认
              button.btn.btn-default.btn-small(@click.stop="resetPlanMethod") 取消
      span.custom-plan(slot="4" v-show="selectPlanMethod == 4")

        .custom-plan-select(v-show="customPlanMethod == ''", @click.stop="stop")
          i.triangle
          p 自定义筛选Top20计划：
          p
            v-select(
              v-model="planOrder",
              :options="planIndices"
              )
            v-select(
              v-model="planIsasc",
              :options="isascList"
              )
          .btn-wrap
              button.btn.btn-primary.btn-small(@click.stop="planMethodSubmit") 确认
              button.btn.btn-default.btn-small(@click.stop="resetPlanMethod") 取消

    .zone.opt-zone.layout-defaultmg
      header
        span.title-icon.analysis-pie
        | 数据分析
      .opt-tool-row
        TimeSpan(:filters="timeSpanType",
          @change="onTimespanChange",
          :custom="false")
        .floatr.mgtop6(v-show="planListShow && planList.length >0")
          v-select(
            v-model="planSelected",
            :options="planList"
            )
        .floatr
          v-radio-group(
            v-if="currentChart == 'line'",
            v-model = "indiceSelected",
            name = "indice",
            :options = "indiceList"
          )
          span(v-show="currentView == 'overall' && target == 2")
            button.btn.btn-white.btn-small(
              :class="{'btn-primary': currentChart == 'line'}",
              @click="currentChart = 'line'"
              ) 趋势图
            button.btn.btn-white(
                :class="{'btn-primary': currentChart == 'quad'}",
                @click="currentChart = 'quad'"
            ) 四象限图
      pred-line-chart(
        v-if="currentChart == 'line'",
        :legend="legend",
        :xAxis="chartXAxis",
        :series="chartSeries",
        :predseries="predChartSeries",
        :lineXAxis="lineXAxis",
        :areaXAxis="areaXAxis")        

      QuadChart(
        v-if="currentChart == 'quad' && target == 2",
        :listSeries="quadListSeries",
        :avgSeries="quadAvgSeries",
        :loading="quadLoading",
        :axisNames="quadNames",
        @quadPosition="setQuadPosition"
        )

      p.chart-tip(v-show="chartTip") {{chartTip}}

    .zone.opt-zone.layout-defaultmg

      header
        span.title-icon.analysis-exchange
        | 问题诊断及优化建议
        div.floatr(v-show="currentView == 'overall' && target == 1 && dianjingID")
          span.btn.btn-icon
            i.fa.fa-eye
            a(:href="toViewProcess",
              target="_blank") 查看分析过程


      div.problem(v-if="currentView == 'overall'")
        .problem-item(v-for="problem,index in problems")
          span.index-box.f14(:class="levelClassName(problem.level)") {{index+1}}
          span.f14 {{problem.problemDesc}}
          ul.advice-list
            li.advice(v-for="advice,adviceIndex in problem.advices")
              span(v-html="adviceDefaultTip(advice)")
              span(v-show="!advice.show && advice.module != 'landingPage' ") （已采纳
                i.red  {{advice.act_suggest_num}}
                |  个）
              //确保prompt是字符串
              v-tooltip(
                v-show="advice.prompt + ''", 
                :tip="advice.prompt + ''",
                pos="right")
                i.fa.fa-question-circle(style="margin-left: 5px;")
              span.floatr.btn.btn-icon(
                v-show="!advice.show",
                @click="openAdviceTable(advice)") 查看详情
                i.fa.fa-angle-double-right

              span.floatr.btn.btn-icon(
                v-show="advice.show",
                @click="closeAdviceTable(advice)") 收起
                i.fa.fa-angle-down
              .reason-content(v-if="advice.show == true && adviceList.length == 0")
                p.center.mg10 今日推荐意见均已添加至操作列表模板，进入 
                  i.link-opt
                    a(:href="toOperateList" target="_blank") 操作列表
                  | 可同步至点睛模板

              .reason-content(v-if="advice.show == true && adviceList.length")
                ServiceAdviceTable(v-if="advice.module == 'service'", 
                              :isAllChecked = '!addToOptTableSucTipShow',
                              @pageChange = "pageChange",
                              :list = "adviceList"
                            )
                KrAdviceTable(v-if="advice.module == 'kr'", 
                              :isAllChecked = '!addToOptTableSucTipShow',
                              @pageChange = "pageChange",
                              :list = "adviceList"
                            )
                PriceAdviceTable(v-if="advice.module == 'price'",
                              :isAllChecked = '!addToOptTableSucTipShow',
                              @pageChange = "pageChange",
                              :list = "adviceList"
                            )
                PauseAdviceTable(v-if="advice.module == 'krPause'",
                              :isAllChecked = '!addToOptTableSucTipShow',
                              @pageChange = "pageChange",
                              :list = "adviceList"
                            )
                BudgetAdviceTable(v-if="advice.module == 'accountBudget' || advice.module == 'planBudget'", 
                              :isAllChecked = '!addToOptTableSucTipShow',
                              :bgtype = "advice.module == 'accountBudget' ? 'custname' : 'plan'",
                              @pageChange = "pageChange",
                              :list = "adviceList"
                            )
                LpAdviceTable(v-if="advice.module == 'landingPage'", 
                              :list = "adviceList",
                              :isAllChecked = '!addToOptTableSucTipShow',
                              :hasCheckbox = "false"
                            )
                .button-wrapper(v-show="advice.module != 'landingPage'")
                  .btn.btn-primary(@click="addToOptTable(advice)") 添加至操作列表
                  span.add-opt-tip(v-show="addToOptTableSuccess")
                    img.fade-rocket-leave(v-show="!addToOptTableSucTipShow", src="https://p5.ssl.qhimg.com/t018b5e325e0f47b754.png")
                    span(v-if="addToOptTableSucTipShow") 采纳的建议已添加至操作列表模板，进入 
                        i.link-opt
                          a(:href="toOperateList" target="_blank") 操作列表
                        | 可同步至点睛模板
        p.center(v-show="problems.length == 0") 暂无相关推荐
      div.plan-problem.section(v-if="currentView == 'section'", :id="'section'")
        fold-table(
            :columns="columns",
            :list="sectionAdviceList")
            template(slot="opt-td", scope="props") 
              span.btn.btn-icon(@click="openPlanAdviceTable(props.item)" v-show="!props.item.show") 优化建议 
                i.fa.fa-angle-double-right
              span.btn.btn-icon(@click="closePlanAdviceTable(props.item)" v-show="props.item.show") 收起 
                i.fa.fa-angle-down
            template(slot="flod-tr", scope="props")
              .problem-item
                ul.advice-list
                  li.advice(v-for="advice,adviceIndex in props.item.problem")
                    span(v-html="adviceDefaultTip(advice)")
                    span(v-show="!advice.show && advice.module != 'landingPage'") （已采纳
                      i.red  {{advice.act_suggest_num}}
                      |  个）
                    v-tooltip(
                      v-show="advice.prompt + ''",
                      :tip="advice.prompt + ''",
                      pos="right")
                      i.fa.fa-question-circle(style="margin-left: 5px;")
                    span.floatr.btn.btn-icon(
                      v-show="!advice.show",
                      @click="openAdviceTable(advice)") 查看详情
                      i.fa.fa-angle-double-right
                    span.floatr.btn.btn-icon(
                      v-show="advice.show",
                      @click="closeAdviceTable(advice)") 收起
                      i.fa.fa-angle-down

                    .reason-content(v-if="advice.show == true && adviceList.length == 0")
                      p.center.mg10 今日推荐意见均已添加至操作列表模板，进入 
                        i.link-opt
                          a(:href="toOperateList" target="_blank") 操作列表
                        | 可同步至点睛模板
                    .reason-content(v-if="advice.show == true && adviceList.length")
                      ServiceAdviceTable(v-if="advice.module == 'service'", 
                                    :isAllChecked = '!addToOptTableSucTipShow',
                                    @pageChange = "pageChange",
                                    :list = "adviceList"
                                  )
                      KrAdviceTable(v-if="advice.module == 'kr'", 
                                    :isAllChecked = '!addToOptTableSucTipShow',
                                    @pageChange = "pageChange",
                                    :list = "adviceList"
                                  )
                      PriceAdviceTable(v-if="advice.module == 'price'",
                                    :isAllChecked = '!addToOptTableSucTipShow',
                                    @pageChange = "pageChange",
                                    :list = "adviceList"
                                  )
                      PauseAdviceTable(v-if="advice.module == 'krPause'",
                                    :isAllChecked = '!addToOptTableSucTipShow',
                                    @pageChange = "pageChange",
                                    :list = "adviceList"
                      )
                      BudgetAdviceTable(v-if="advice.module == 'accountBudget' || advice.module == 'planBudget'", 
                                    :isAllChecked = '!addToOptTableSucTipShow',
                                    :bgtype = "advice.module == 'accountBudget' ? 'custname' : 'plan'",
                                    @pageChange = "pageChange",
                                    :list = "adviceList"
                                  )
                      LpAdviceTable(v-if="advice.module == 'landingPage'", 
                                    :isAllChecked = '!addToOptTableSucTipShow',
                                    :list = "adviceList",
                                    :hasCheckbox = "false"
                                  )
                      .button-wrapper(v-show="advice.module != 'landingPage'")
                        .btn.btn-primary(@click="addToOptTable(advice)") 添加至操作列表
                        span.add-opt-tip(v-show="addToOptTableSuccess")
                          img.fade-rocket-leave(v-show="!addToOptTableSucTipShow", src="https://p5.ssl.qhimg.com/t018b5e325e0f47b754.png")
                          span(v-if="addToOptTableSucTipShow") 采纳的建议已添加至操作列表模板，进入 
                              i.link-opt
                                a(:href="'/web/operatelist'" target="_blank") 操作列表
                              | 可同步至点睛模板

    p.problem-tip(v-show="currentView == 'overall' && hasConvertionFlag") 说明： 红色图标为急需采纳的建议，灰色图标为持续优化需采纳的建议
    img(:src="logsrc" v-show="false")
    v-modal(:visible="emptyPlanAdviceShow",
            :title="''",
            @closemodal="emptyPlanAdviceShow = false"
    )
      .modal-bd.public-modal
        .msg-wrap
          p 
            i.fa.fa-exclamation-triangle.icon.icon-warn
            span 暂无优化建议，可能原因如下：
          p 1、按照您的筛选规则，账户内没有相应计划。
          p 2、筛选出的计划昨日推广数据较少。
        .btn-wrap
          button.btn.btn-primary.btn-small(@click.stop="emptyPlanAdviceShow = false") 确认
</template>
<script>
  import Vue from 'vue'
  import Mixin from '../mixin.js'
  import { getDateString } from '../../script/util';
  import Table from '../../component/complex-table.vue'
  import FoldTable from '../../component/fold-table.vue'
  import PredLineChart from '../../component/charts/predictlinechart.vue'
  import SearchSelect from '../../component/search-select.vue'
  import Timepicker from '../../component/timepicker.vue'
  import Casecade from '../../component/casecade.vue'
  import KrAdviceTable from './kr_advice_table.vue'
  import ServiceAdviceTable from './service_advice_table.vue'
  import BudgetAdviceTable from './budget_advice_table.vue'
  import PriceAdviceTable from './price_advice_table.vue'
  import PauseAdviceTable from './pause_advice_table.vue'
  import LpAdviceTable from './lp_advice_table.vue'

  const matchTypes = [{
          value: 1,
          label: "广泛匹配"
        }, {
          value: 2,
          label: "智能短语匹配"
        }, {
          value: 3,
          label: "普通短语匹配"
        }, {
          value: 4,
          label: "精确匹配"
        }]
  export default {
    components: {
      'complex-table': Table,
      'fold-table': FoldTable,
      'pred-line-chart': PredLineChart,
      'search-select': SearchSelect,
      Timepicker,
      Casecade,
      KrAdviceTable,
      ServiceAdviceTable,
      PriceAdviceTable,
      PauseAdviceTable,
      BudgetAdviceTable,
      LpAdviceTable
    },
    mixins: [Mixin],
    data() {
      return {
        currentPlanId: 0,
        showOps: false,
        emptyPlanAdviceShow: false,
        indiceSelected: 'tnum',
        newAcceptNum: 0,
        currentModule: "",
        logsrc: "",
        rocketSrc: "",
        noConvertion: false,
        advicePriceWarning: "",
        matchTypes,
        addToOptTableSuccess: false,
        addToOptTableSucTipShow: false,
        timePickerShow : false,
        searchPlanShow: false,
        planOrder: 'tnum',
        planName: '',
        planList: [],
        planCheckedList: [],
        planSelected: '',
        allPlanList: [],
        customPlanMethod: '',
        customPlanMethodBak: [],
        planIsasc: '1',
        isascList: [{
            value: "1",
            label: "下降"
          },{
            value: "2",
            label: "下降比例"
          },{
            value: "3",
            label: "上升"
          },{
            value: "4",
            label: "上升比例"
          }],
        selectPlanMethod: "1",
        chartData: {},
        quadPosition: '',
        quadListSeries: [],
        quadAvgSeries: {},
        quadLoading: false,
        quadNames : {
          xName : '点击率均值',
          yName : '展现量均值'
        },
        problems: [],
        adviceList: [],
        adviceTotal: 16,
        advicePg: 1,
        advicePs: 10,
        currentReason: 0,
        reasons: [],
        legend: [],
        chartXAxis: [],
        chartSeries: [],
        predChartSeries: [],
        lineXAxis: [],
        areaXAxis: [],
        
        currentChart: 'line',
        transelected: 'null',
        transList: [{
                label: '全部转化',
                value: "null"
              }],
        dianjingID: this.$store.state.dianjingID,
        dianjingIDList: [],
        target: '',
        targetList: [],
        currentView: "overall",
        tabViews: [
          {
            comp: "overall",
            title: "整体优化",
          },
          {
            comp: "section",
            title: "分计划优化"
          }
        ],
        sectionAdviceList: [],
        accountAdviceList: [],
        planAdvice: [],
        currentAccountAdviceList: [],
        isAllAdviceChecked : false,
      }
    },
    computed: {
      planIndices(){ 
        let list =[{
            value: "tnum",
            label: "转化次数"
          },{
            value: "adcost",
            label: "消费"
          },{
            value: "adpv",
            label: "展现量"
          },{
            value: "adclick",
            label: "点击量"
          }]
        if(this.target == 2) {
          list.splice(0,1)
        }
        return list
      },
      indiceList() {
        let list = [{
            title: "转化次数",
            value: "tnum"
          },{
            title: "展现量",
            value: "adpv"
          },{
            title: "点击量",
            value: "adclick"
          },{
            title: "点击率",
            value: "adctr"
          }]

        if(this.target == 2) {
          list.splice(0,1)
        }
        return list
      },
      planMethods() {
        let targetText = this.target == 1 ? '转化次数' : '消费'
        return [{
            value: "1",
            title: targetText + "Top20计划"
          },{
            value: "2",
            title: targetText + "下降Top20计划"
          },{
            value: "3",
            title: targetText + "下降比例Top20计划"
          },{
            value: "4",
            title: "自定义筛选计划"
          },{
            value: "5",
            title: "手动筛选计划"
          }]
      },
      hasEditItem() {
        let hasEdit = false
        _.map(this.$store.state.tableCheckList, (item) => {

          for(let key in item) {
            if(/^priceEdit$/.test(key) && item[key]) {
              hasEdit =  true
              return 
            }
          }
        })
        return hasEdit
      },
      planListShow() {
        return this.currentView == 'section' && (
                (this.selectPlanMethod !='5' && this.planList.length > 0) ||
                (this.selectPlanMethod == '5' && !this.searchPlanShow)
              )
      },
      toViewProcess() {
        return '/web/viewprocess?dj=' + this.dianjingID;
      },
      toOperateList() {
        return '/web/operatelist?dj=' + this.dianjingID;
      },
      timeSpanType() {
        return this.currentChart == 'quad' ? 'only7' : '7a'
      },
      hasConvertionFlag() {
        return !(this.target == 1 && this.noConvertion)
      },
      domainId() {
        return this.$store.state.domainId
      },
      query() {
        let obj = {
          domainId: this.domainId,
          aoTarget: this.target,
          timespan: new Date().getTime()
        }
        if(this.dianjingID) {
          obj.djid = this.dianjingID
        }
        return obj
      },
      uiError() {
        return this.$store.state.uiError
      },
      chartTip() {
        if(this.currentChart == 'quad' && !_.isEmpty(this.quadListSeries)) {
          let quadTip = [
          "数据解读：您的账户与同行业客户相比，展现量、点击率表现均优，可采纳优化建议继续优化账户水平。",
          "数据解读：您的账户与同行业客户相比，点击率较低，急需优化，展现量可持续优化。",
          "数据解读：您的账户与同行相比，展现量、点击率均低于平均水平，急需优化。",
          "数据解读：您的账户与同行业客户相比，展现量较低，急需优化，点击率可持续优化。"
          ]
          return quadTip[this.quadPosition - 1]
        } else if(this.currentChart == 'line' && !_.isEmpty(this.chartSeries)){
          let currentIndice = _.find(this.indiceList, {value:this.indiceSelected}).title
          return `数据解读：基于您网站当前${currentIndice}水平，采纳以下全部建议后预估${currentIndice}走势为上图蓝色曲线`
        } else {
          return ''
        } 
      },
      problemsApi() {
        let api = {
          overall : "/api/aoDiagnosis/account",
          section : "/api/aoDiagnosis/plan"
        }
        return api[this.currentView]
      },
      lineChartApi() {
        let api = {
          overall : "/api/aoDiagnosis/accountReport",
          section : "/api/aoDiagnosis/planReport"
        }
        return api[this.currentView]
      },
      columns() {
        let currentIndice = _.isEmpty(this.customPlanMethodBak) ?
                            this.target == 2 ? "adcost" : "tnum" :
                            this.customPlanMethodBak[0]
        let defaultColumns = [
          {
            title: "",
            children: [
              {
                title: "",
                key: "planId",
                class: "center",
                render: (index, value, item) => {
                  return index + 1
                }
              },{
                title: "推广计划",
                key: "plan"
              },{
                title: this.target == 2 ? "消费" : "转化次数",
                class: "right",
                key: this.target == 2 ? "adcost" : "tnum"
              },{
                title: "环比变化",
                class: "right",
                key: "prop_" + currentIndice,
                render: (index, value, item) => {
                  if (typeof value === 'number') return ''
                  let arrowStyle = value == 0 ? '' : value > 0 ? '<i class="fa margin_icon fa-long-arrow-up red"></i>' : '<i class="fa margin_icon fa-long-arrow-down green"></i>'
                  return (Math.abs(value) * 100).toFixed(2) + '%' + arrowStyle
                }
              }
            ]
          },{
            title: "问题诊断",
            children: [
            {
              title: "展现量低",
              class: "center",
              key: "pv",
              render: this.problemRender
            },{
              title: "点击率低",
              class: "center",
              render: this.problemRender,
              key: "click"
            },{
              title: "转化率低",
              key: "conv",
              class: "center",
              render: this.problemRender
            },{
              title: "时长/预算不合理",
              class: "center",
              render: this.problemRender,
              key: "budget"
            },]
          },{
            title: "",
            children: [{
              title: "操作",
              class: "center",
              key: "opt"
            }]
          }
        ]
        let isAddOtherColumn = this.selectPlanMethod == '4' && this.customPlanMethod != ''
        //优化转化时追加指标
        if(isAddOtherColumn && this.target == 1 && currentIndice != 'tnum') {
            defaultColumns[0].children.splice(3, 0 ,{
                title: _.find(this.planIndices, {value: currentIndice}).label,
                class: "right",
                key: currentIndice
            })
        }
        //优化展现时替换指标
        if(isAddOtherColumn && this.target == 2) {
            defaultColumns[0].children.splice(2, 1 ,{
                title: _.find(this.planIndices, {value: currentIndice}).label,
                class: "right",
                key: currentIndice
            })
        }
        //优化展现中不显示转化率低
        if(this.target == 2) {
          defaultColumns[1].children.splice(2,1)
        }
        //自定义计划时显示展点消
        if(this.selectPlanMethod == '5' && !_.isEmpty(this.planList)) {
          let child = [{
                title: "",
                key: "planId",
                class: "center",
                render: (index, value, item) => {
                  return index + 1
                }
              },{
                title: "推广计划",
                key: "plan"
              },{
                title: "展现量",
                class: "right",
                key: 'adpv'
              },{
                title: "点击量",
                class: "right",
                key: 'adclick'
              },{
                title: "消费",
                class: "right",
                key: 'adcost'
              }]
          defaultColumns[0].children = child
        }
        return defaultColumns
      }
    },
    watch: {
      searchPlanShow(newVal, oldVal) {
        if(newVal) {
          this.planName = ''
          this.getPlanList()
        }
      },
      domainId() {
        this.dianjingID = ''
        this.target = ''
        this.currentChart = 'line'
        this.getSiteDianjingIDsWithoutWhole()
      },
      //没有点睛ID默认页面没有数据显示
      dianjingIDList(newVal, oldVal) {
        if(_.isEmpty(newVal)) {
          this.target = 0
          this.chartData = []
          this.chartSeries = []
          this.quadListSeries = []
          this.problems = []
          this.sectionAdviceList = []
        }
      },
      dianjingID(newVal, oldVal) {
        if(newVal == oldVal || newVal == '') return 
        this.$store.commit("SET_DIANJINGID", this.dianjingID)
        this.currentView = 'overall'
        this.currentChart = 'line'
        this.selectPlanMethod = '1'
        this.getTarget()
      },
      planSelected(newVal, oldVal) {
        if(newVal == oldVal) return 
        this.getProblems()
        this.getChartData()
      },
      planList(newVal, oldVal) {
        if(this.selectPlanMethod == '5' || newVal.length == 0 || newVal == oldVal) return 
        this.getProblems()
      },
      uiError() {
        this.$Modal.warn(this.uiError.errMsg)
      },
      target(newVal, oldVal) {
        //target为0或者''不进行其他请求
        if(this.target == '') return
        if(this.hasConvertionFlag) {
          this.getChartData()
          this.getProblems()
        }
        this.indiceSelected = this.target == 2 ? 'adpv' : 'tnum'
        this.$nextTick(() => {
          this.planOrder = this.target == 2 ? 'adcost' : 'tnum'
        })
      },
      indiceSelected() {
        this.getLineChartData()
      },
      selectPlanMethod(newVal, oldVal) {
        if(this.currentView != 'overall') {
          if(newVal != '4') {
            this.getPlanList()
          }
          if(newVal == '5') {
            this.planList = []
          } else {
            this.planCheckedList = []
          }
          this.customPlanMethodBak = []
          this.customPlanMethod = ''
          this.planName = ''
        }
      }
    },
    created() {
      this.getSiteDianjingIDsWithoutWhole()
    },
    mounted() {
      this.timeSpan = this.$store.state.dateAsParam
      this.getTarget()
    },
    methods: {
      stop() {},
      closeCustomPlanMethod() {
        this.customPlanMethodBak = []
        this.selectPlanMethod = '1'
        this.planOrder = this.planIndices[0].value
        this.planIsasc = this.isascList[0].value
      },
      editCustomPlanMethod() {
        this.customPlanMethod = ''
      },
      problemRender(index, value, item) {
        let classname = value == 1 ? 'red' : 'grey'
        return `<span class="${classname}">
        <i class="fa fa-star"></i>
        </span>`
      },
      setQuadPosition(position) {
        this.quadPosition = position
      },
      //添加至操作列表
      addToOptTable(advice) {
        if(this.hasEditItem) return this.$Modal.warn("请保存编辑项")
        if(this.$store.state.tableCheckList == 0) return this.$Modal.warn("请选择采纳的建议！")
        let paramsData = _.extend({
                       module: advice.module,
                       srcType: this.currentView == 'overall' ? 'account' : 'plan',
                       data: JSON.stringify(this.$store.state.tableCheckList)
                     }, this.query)
        const adviceListPromise = this.$http.post('/api/aoTmpl/addDetail', paramsData, {emulateJSON: true});
        this.$store.dispatch("VUE_HTTP", [adviceListPromise])
          .then((res) => {
            if(res) {
              //记录添加了多少条
              this.newAcceptNum += this.$store.state.tableCheckList.length
              this.$store.dispatch("SET_TABLE_CHECKLIST", [])
              this.addToOptTableSuccess = true
              setTimeout(() => {
                this.addToOptTableSucTipShow = true
                //重新回去推荐建议列表
                if(this.currentView == 'overall') {
                  this.getAdviceList(advice)
                } else {
                  this.getAdviceList(advice, this.currentPlanId)
                }
              }, 1000)
            }
          })
      },
      //获取四象限数据
      getQuadChartData() {
        this.quadLoading = true
        this.quadListSeries = [];
        const quadPromise = this.$http.get('/api/aoAnalysis/mapReport', {
            params: _.extend({
              maptype: 1
            }, this.query)
          })
        this.$store.dispatch("VUE_HTTP", [quadPromise])
          .then(res => {
            if(res ) {
              this.quadLoading = false
              if (res.errno) {
                this.$Modal.warn(res.errMsg)
                return 
              } else {
                if(res.avg && res.list){
                  this.quadAvgSeries = {
                    avgValue1: res.avg.avg7adctr,
                    avgValue2: res.avg.avg7adpv
                  }
                  this.quadListSeries = _.map(res.list, item => {
                    let obj = {
                      value1: item.avg7adctr,
                      value2: item.avg7adpv
                    }
                    if(item.self) {
                      obj.self = item.self
                    }
                    return obj
                  })
                }
                return 
              }
            }
          })
      },
      toggleCheckPlan(plan, e) {
        const maxPlanSize = 20
        if(plan.checked){
          //超出最大限制，从数组头部去掉一个
          if(this.planCheckedList.length >= maxPlanSize) {
            this.$set(this.planCheckedList[0], 'checked', false)
            this.planCheckedList.splice(0,1)
          }
          this.planCheckedList.push(plan)
        } else {
          this.planCheckedList = _.filter(this.planCheckedList, item => item.checked)
        }
      },
      resetCheckPlanList() {
        this.planCheckedList = []
        this.allPlanList.map(item => {
          this.$set(item, 'checked', false)
        })
      },
      getPlanList() {
        let paramsData = _.extend({
                                  orderType: this.selectPlanMethod,
                                  plan: this.planName,
                                  start: this.timeSpan.start,
                                  end: this.timeSpan.end
                                }, this.query)
        if(this.selectPlanMethod == 4) {
          paramsData.order = this.planOrder
          paramsData.isasc = this.planIsasc
        }
        const planListPromise = this.$http.get('/api/aoDiagnosis/planFilter', {
                                params: paramsData
                              })
        this.$store.dispatch('VUE_HTTP', [planListPromise])
          .then((res) => {
            if(res) {
              if(res.list.length == 0 && this.planName == '') {
                this.planSelected = ''
                this.planList = []
                this.chartData = []
                this.emptyPlanAdviceShow = true
                return
              }
              if(this.selectPlanMethod == 5) {
                this.allPlanList = _.uniqBy(_.concat([], this.planCheckedList, res.list.map(item => {
                                      item.value = item.planId
                                      item.label = item.plan
                                      return item
                                    })), 'value')
                this.searchPlanShow = true
              } else {
                this.planList = []
                this.planList = res.list.map(item => {
                                  item.value = item.planId
                                  item.label = item.plan
                                  return item
                                })
                this.$nextTick( () => {
                  this.planSelected = res.list[0].planId
                })
              }
            }
          })
      },
      planMethodSubmit() {
        if(this.selectPlanMethod == '5') {
          this.planList = _.cloneDeep(this.planCheckedList)
          this.searchPlanShow = false
          if(!_.isEmpty(this.planList)) {
            this.$nextTick( () => {
              this.planSelected = this.planList[0].value
              this.getProblems()
            } )
          } else {
            this.selectPlanMethod = '1'
          }

        } else {
          this.customPlanMethodBak = [this.planOrder, this.planIsasc]
          let order = _.find(this.planIndices, {value: this.planOrder}).label
          let isasc = _.find(this.isascList, {value: this.planIsasc}).label
          this.customPlanMethod = `${order}${isasc}Top20计划`
          this.getPlanList()
        }
      },
      resetPlanMethod() {
        this.planName = ''
        if(this.selectPlanMethod == '5') {
          let planCheckedList = _.cloneDeep(this.planList)
          this.resetCheckPlanList()
          this.planCheckedList = planCheckedList
          this.allPlanList = _.uniqBy(_.concat(this.planCheckedList, this.allPlanList), 'value')
          this.searchPlanShow = false
          // 未勾选时取消回到默认首项
          if(_.isEmpty(this.planCheckedList)) {
            this.selectPlanMethod = "1"
          }
        } else {
          if(_.isEmpty(this.customPlanMethodBak)){
            this.selectPlanMethod = "1"
          } else {
            [this.planOrder, this.planIsasc] = this.customPlanMethodBak
            this.planMethodSubmit()
          }
        }
      },
      //账户问题建议折叠展开
      openAdviceTable(advice) {
        if(this.$store.state.tableCheckList.length != 0) {
          this.$Modal.confirm('采纳的建议还没有添加至操作列表，是否放弃？', result => {
            if(result) {
              this.closeAndOpenAdvice(advice)
            }
          })
        } else {
          this.closeAndOpenAdvice(advice)
        }
      },
      closeAndOpenAdvice(advice){
        this.$store.dispatch("SET_TABLE_CHECKLIST", [])
        //获取推荐列表
        //遍历problems保证仅有一个建议table展开
        if(this.currentView == 'overall') {
          this.getAdviceList(advice)
          this.problems.map(item => {
            item.advices.map(adviceItem => {
              if(advice !== adviceItem) {
                if(adviceItem.show) {
                  //更新采纳意见个数
                  this.$set(adviceItem, 'act_suggest_num', +adviceItem.act_suggest_num + this.newAcceptNum)
                }
                this.$set(adviceItem, 'show', false)
              }
            })
          })
        }else {
          this.getAdviceList(advice, this.currentPlanId)
          this.planAdvice.map(item => {
            if(item != advice) {
              if(item.show) {
                //更新采纳意见个数
                this.$set(item, 'act_suggest_num', +item.act_suggest_num + this.newAcceptNum)
              }
              this.$set(item, 'show', false)
            }
          })
        }
        this.newAcceptNum = 0
        this.addToOptTableSuccess = false
        this.addToOptTableSucTipShow = false
      },
      closeAdviceTable(advice) {
        if(this.$store.state.tableCheckList.length != 0) {
          this.$Modal.confirm('采纳的建议还没有添加至操作列表，是否放弃？', result => {
            if(result) {
              this.giveUpAdvice(advice)
            }
          })
        } else {
          this.giveUpAdvice(advice)
        }
      },
      giveUpAdvice(advice) {
        this.$set(advice, 'act_suggest_num', +advice.act_suggest_num + this.newAcceptNum)
        this.newAcceptNum = 0
        this.$store.dispatch("SET_TABLE_CHECKLIST", [])
        advice.show = false
        this.addToOptTableSuccess = false
        this.addToOptTableSucTipShow = false
      },
      //计划问题折叠展开
      openPlanAdviceTable(advice) {
        //获取推荐列表
        this.currentPlanId = advice.planId;
        this.getAdviceList(advice.problem[0], advice.planId)
        this.$set(advice, 'show', true)
        this.sectionAdviceList.map(item => {
          if(advice !== item) {
            this.$set(item, 'show', false)
            let problems = _.map(item.problem, (problem) => {
              this.$set(problem, 'show', false)
                return problem
              })
            this.$set(item, 'problem', problems)
          }
        })
        this.planAdvice = advice.problem
      },
      closePlanAdviceTable(advice) {
        this.$set(advice, 'show', false)
        let problems = _.map(advice.problem, (problem) => {
          this.$set(problem, 'show', false)
          return problem
        })
        this.$set(advice, 'problem', problems)
        this.addToOptTableSucTipShow = false
      },
      levelClassName(level) {
        return level == 1 ? '' : 'grey'
      },
      transTypeName(key) {
        let transType = ['全部转化', '页面转化', '事件转化', '时长转化', '页数转化']
        return transType[key]
      },
      //获取建议列表
      getAdviceList(reason, planid = '') {
        this.adviceList = []
        this.currentModule = reason.module
        let params = _.extend({
                                reason: reason.reason,
                                start: this.timeSpan.start,
                                end: this.timeSpan.end
                              }, this.query)
        if(this.currentView == 'section') {
          params.planList = planid.toString()
        }
        let advicePromise = this.$http.get(`/api/aoRecommend/${reason.module}`, {
                              params: params
                            })
        this.$store.dispatch("VUE_HTTP", [ advicePromise ])
          .then((res) => {
            if(res){
              this.adviceList = res.list
              this.$set(reason, 'show', true)
            }
          })
      },
      //获取问题诊断
      getProblems() {
        //置空
        this.sectionAdviceList = []
        this.planAdvice = []
        this.problems = []
        if(this.currentView == 'section' && this.planSelected == '') {
          this.sectionAdviceList = []
          return
        } 
        let params = _.extend({
          start: this.timeSpan.start,
          end: this.timeSpan.end
        }, this.query)
        if(this.currentView == 'section') {
          params.planList = _.map(this.planList, item => item.planId).join(',')
        }
        let problemPromise = this.$http.get(this.problemsApi, {
                                params: params
                              })
        this.$store.dispatch("VUE_HTTP", [problemPromise])
          .then((res) => {
            if(res) {
              let problemList = []
              if(this.currentView == 'section') {
                problemList = _.map(res.list, item => {
                  _.map(item.problem, (problem, index) => {
                    let problemName = {1: "pv", 2:"click", 3:"conv", 4:"budget"}
                    item[problemName[problem.problemId]] = problem.level
                    problem.show = false
                    return problem
                  })
                  item.show = false 
                  return item
                })

                if(!_.isEmpty(problemList)) {
                  problemList[0].show = true
                  this.sectionAdviceList = problemList
                  this.planAdvice = problemList[0].problem
                  this.currentPlanId = problemList[0].planId;
                  this.getAdviceList(problemList[0].problem[0],problemList[0].planId)
                }
              } else if(this.currentView == 'overall') {
                let list = _.groupBy(res.list,'problemId')
                _.forIn(list, (value, key) => {
                  value = _.map(value, (item,index) => {
                      item.show = false
                      return item
                    })
                  problemList.push({
                    problemId: value[0].problemId,
                    level: value[0].level,
                    problemDesc: value[0].problemDesc,
                    advices: value
                  })
                })
                this.problems = problemList
                //获取第一条推荐内容
                !_.isEmpty(problemList) && this.getAdviceList(problemList[0].advices[0])
              } 
            }
          })
      },
      //获取全部转化list
      fetchTransList() {
        if(!this.domainId) return
        let translistPromise = this.$http.get('/api/trans/list', {
                                  params: {
                                    ps: 100,
                                    pg: 1,
                                    cycle: "day",
                                    domainId: this.domainId,
                                    timespan: new Date().getTime()
                                  }
                                })
        this.$store.dispatch("VUE_HTTP", [translistPromise])
          .then((res) => {
            if(res){
              let transList = _.groupBy(_.get( res, 'list'),'type')
              let newTransList = [{ label: '全部转化',
                value: "null"
              }]
              //根据v-select所需options的格式进行修改
              _.forIn(transList, (value,key) => {
                newTransList.push({
                  label: this.transTypeName(key),
                  options: value.map(item => {
                    return {
                      value: item.id,
                      label: '' + item.name
                    }
                  })
                })
              })
              this.transList = newTransList
            }
          })
      },
      //获取优化目标
      getTarget() {
        this.target = ''
        if(!this.dianjingID) return 
        this.showOps = false
        let targetPromise = this.$http.get('/api/aoDiagnosis/aoTarget', {params: {
          domainId: this.domainId,
          djid: this.dianjingID,
          timespan: new Date().getTime()
        }})
        this.$store.dispatch("VUE_HTTP", [targetPromise])
          .then((res) => {
            if(res) {
              this.target = _.find(res.list, {default:1}).aoTarget
              this.targetList = _.map(res.list, item => {
                return {
                  value: item.aoTarget,
                  title: item.aoTargetDesc,
                  disabled: _.has(item, 'default') || this.target == 2 ? false : true
                }
              })
              //无转化效果时单独处理
              this.noConvertion = this.target == 2 
              if(this.target === 0){
                this.showOps = true;
                return;
              }
            }
          })
      },
      //获取趋势图数据
      getChartData() {
        if(this.currentView == 'section' && this.planSelected == '') {
          this.chartSeries = []
          return 
        }
        if(this.currentChart == 'line'){
          let params = _.extend({
                         start: this.timeSpan.start,
                         end: this.timeSpan.end
                       }, this.query)
          if(this.currentView == 'section') {
            params.planList = this.planSelected
          }
          let lineChartPromise = this.$http.get(this.lineChartApi, {params: params})
          this.$store.dispatch('VUE_HTTP', [lineChartPromise])
            .then((res) => {
              if(res) {
                this.chartData = res
                this.$store.state.end = getDateString.yestoday();
                this.getLineChartData()
              }
            })
          } else {
            this.getQuadChartData()
          }
      },
      //趋势图所需数据
      getLineChartData() {
        let chartData = _.cloneDeep(this.chartData)
        chartData.selectedIndice = this.indiceSelected
        let [legend, xAxis, series, predSeries, lineXAxis, areaXAxis] = [[],[],[],[],[],[]]
        if(!_.isEmpty(chartData.trend) && !_.isEmpty(chartData.history)) {
          [legend, xAxis, series, predSeries, lineXAxis, areaXAxis] = this.processPredictData(chartData)
        } 
        this.legend = legend
        this.chartXAxis = xAxis
        this.chartSeries = series
        this.predChartSeries = predSeries
        this.lineXAxis = lineXAxis
        this.areaXAxis = areaXAxis
      },
      //建议文案
      adviceDefaultTip(advice) {
        const modules = {
          kr: '关键词拓展',
          price: '关键词优化',
          service: '投放时间优化',
          landingPage: '落地页优化',
          accountBudget: '整体预算优化',
          planBudget: '计划预算优化',
          krPause: '暂停关键词'
        }
        let defaultTip = `${modules[advice.module]}：为您推荐 <i class="red">${advice.org_suggest_num}</i> 条建议`
        if(advice.problemId == 3) {
          defaultTip += `，全部采纳预计展现量提升 <i class="red">${advice.esti_add_adpv}</i>，点击量提升 <i class="red">${advice.esti_add_adclick}</i>`
        } else if(advice.module == 'kr' || (advice.module == 'price' && advice.problemId == 1)) {
          defaultTip += `，全部采纳预计展现量提升 <i class="red">${advice.esti_add_adpv}</i>`
        } else if(advice.module == 'price' && advice.problemId == 2) {
          defaultTip += `，全部采纳预计点击量提升 <i class="red">${advice.esti_add_adclick}</i>`
        }
        return defaultTip
      },
      //时间切换
      onTimespanChange(time) {
        this.timeSpan = time
        this.getChartData()
      },
      changeViewTo(comp) {
        this.currentChart = 'line'
        let view = _.find(this.tabViews, { comp });
        if(view){
          this.currentView = view.comp;
          this.currentView == 'section' && this.getPlanList()
        }
        //图表数据置空 
        this.chartData = []
        this.selectPlanMethod = '1'
        this.getChartData()
        //this.chartSeries = []
        this.getProblems()
      },
      pageChange(list) {
        let loglist = list.map(item => {
            return  {
              id: item.id || '',
              planId: item.planId || '',
              groupId: item.groupId || '',
              bidword: item.bidword || '',
              bidwordId: item.bidwordId || ''
            }
          })
        this.logsrc = `_log.gif?custid=${this.dianjingID}&module=${this.currentModule}&list=${JSON.stringify(loglist)}`
      }
    }
  }
</script>
<style scoped>
.mgtop6 {
  margin-top: -6px;
}
.tooltip i {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// optimizeaccount.vue?fe493fbe